module.exports = __webpack_public_path__ + "static/img/banner_lantern_slide_3.47d673f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/banner_lantern_slide_3.jpg
// module id = OKbo
// module chunks = 0